<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							id="filters.search"
							name="filters.search"
							[(ngModel)]="filters.search"
						/>
						<label class="form-label" for="filters.search" for="filters.search">Nazwa wydarzenia</label>
					</div>
					<div class="mb-3">
						<label for="touristGuides" class="mt-3">Pilot</label>
						<ng-select
							id="touristGuide"
							name="touristGuide"
							[(ngModel)]="filters.touristGuide"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of touristGuides" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<div class="form-floating mb-3">
							<select
								class="form-select"
								id="calculated"
								name="calculated"
								[(ngModel)]="filters.calculated"
							>
								<option value="">(wszystkie)</option>
								<option *ngFor="let item of calculated" [value]="item.id">
									{{ item.name }}
								</option>
							</select>
							<label for="calculated">Rozliczony</label>
						</div>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="date_from"
									[(ngModel)]="filters.date_from"
									id="date_from"
								/>
								<label for="date_from" class="form-label">Data wydarzenie od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="date_to"
									[(ngModel)]="filters.date_to"
									id="date_to"
								/>
								<label for="date_to" class="form-label">Data wydarzenia do</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
